<template>
  <ul class="tab-switches">
    <TabSwitch
      v-for="item in items"
      :id="item.id"
      :key="item.id"
      :title="item.title"
      :active="isActive(item.id)"
      :unread="item.unread"
      @click-tab-switch="onClickTabSwitch"
    />
  </ul>
</template>
<script>
import TabSwitch from '../../atoms/tab/TabSwitch.vue'

export default {
  components: {
    TabSwitch
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    isActive(value) {
      return this.activeTab === value
    },
    onClickTabSwitch(value) {
      this.$emit('change-active-tab', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-switches {
  background-color: $white;
  display: flex;
  max-width: $max-contents-width;
  margin: auto;
}
</style>
